import { ethers } from 'ethers';
import artifact from '../contracts/CoinForgeToken.json';

// After a fresh deploy some RPC providers take a moment to index the new
// contract's bytecode — if we call seedLiquidity() before that, ethers'
// eth_estimateGas returns "contract not deployed" and the wallet never even
// prompts. Poll eth_getCode until non-empty (or timeout).
export const waitForBytecode = async (provider, address, { timeoutMs = 30000, intervalMs = 1000 } = {}) => {
  const start = Date.now();
  while (Date.now() - start < timeoutMs) {
    try {
      const code = await provider.getCode(address);
      if (code && code !== '0x' && code !== '0x0') return true;
    } catch (_) { /* transient RPC hiccup — retry */ }
    await new Promise((r) => setTimeout(r, intervalMs));
  }
  return false;
};

// Call seedLiquidity(weth, nfpm) {value: ethAmount} on an already-deployed token.
// Used by both the launch flow (initial seed) and the recovery panel (retry).
export const callSeedLiquidity = async ({ signer, contractAddress, weth, nfpm, ethAmount = '0.01' }) => {
  const c = new ethers.Contract(contractAddress, artifact.abi, signer);
  const tx = await c.seedLiquidity(weth, nfpm, { value: ethers.parseEther(ethAmount) });
  const receipt = await tx.wait();
  return { hash: tx.hash, receipt };
};

// Fallback: 80% burn to 0xdEaD, 20% to creator. Used when LP can't be seeded.
export const callWithdrawUnseeded = async ({ signer, contractAddress }) => {
  const c = new ethers.Contract(contractAddress, artifact.abi, signer);
  const tx = await c.withdrawUnseeded();
  const receipt = await tx.wait();
  return { hash: tx.hash, receipt };
};

// Pre-flight: does the connected wallet have enough ETH to pay for
// {ethAmount} (attached to seedLiquidity) + estimated tx gas?
export const hasEnoughForSeed = async ({ provider, address, ethAmount = '0.01', gasBufferEth = '0.002' }) => {
  const bal = await provider.getBalance(address);
  const needed = ethers.parseEther(ethAmount) + ethers.parseEther(gasBufferEth);
  return { ok: bal >= needed, balance: bal, needed };
};
